import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, RadioGroup, Radio } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepTwo(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    useEffect(() => {
        if (props.datas.CA) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Selon vous, quel pourcentage la «location de logements à court et moyen terme» représente sur votre Chiffre d’affaire ?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue={props.datas.CA}
                        name="radio-buttons-group">
                        <FormControlLabel
                            value="Moins de 25%"
                            control={<Radio name='CA'
                                onChange={(e) => handleChange(e)} />}
                            label="Moins de 25%" />
                        <FormControlLabel
                            value="entre 25% et 50%"
                            control={
                                <Radio name='CA'
                                    onChange={(e) => handleChange(e)} />}
                            label="entre 25% et 50%" />
                        <FormControlLabel
                            value="entre 50% et 75%"
                            control={
                                <Radio name='CA'
                                    onChange={(e) => handleChange(e)} />}
                            label="entre 50% et 75%" />
                        <FormControlLabel
                            value="plus de 75%"
                            control={
                                <Radio name='CA'
                                    onChange={(e) => handleChange(e)} />}
                            label="plus de 75%" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons} />
        </>
    )
}